export class PaginationInfo {

  private _numberOfPage = 0;
  private _totalNumberOfElements = 0;

  static empty() {
    return new PaginationInfo(0, 0, 0);
  }

  constructor(private _numberOfElementsOnPage: number, numberOfPageParam?: number, totalNumberOfElementsParam?: number) {
    if (numberOfPageParam) {
      this._numberOfPage = numberOfPageParam;
    }

    if (totalNumberOfElementsParam) {
      this._totalNumberOfElements = totalNumberOfElementsParam;
    }
  }

  restart() {
    this._numberOfPage = 0;
    this._totalNumberOfElements = 0;
  }

  get nextPage(): number {
    return this._numberOfPage + 1;
  }

  get numberOfPage(): number {
    return this._numberOfPage;
  }

  get numberOfElementsOnPage(): number {
    return this._numberOfElementsOnPage;
  }

  get totalNumberOfElements(): number {
    return this._totalNumberOfElements;
  }

  set totalNumberOfElements(value: number) {
    this._totalNumberOfElements = value;
  }

  set numberOfPage(value: number) {
    this._numberOfPage = value;
  }
}
